module.exports = function getFetchHeaders() {
	let headers = null;

	if (typeof btoa !== "undefined") {
		headers = {
			Authorization: `Basic ${btoa(`gatsby:gatsby`)}`,
		};
	} else {
		headers = {
			Authorization: `Basic ${Buffer.from(`gatsby:gatsby`, "utf-8").toString("base64")}`,
		};
	}

	return headers;
};
